export enum JointType {
  Mitered = 'Mitered',
  Notched = 'Notched',
  Square = 'Square',
  _2InchMiter = '2 Inch Miter',
}
